export default __webpack_public_path__ + "media/images/mailer/icon_email-f2adf131a241347dd21b96ac1f3ebdd3.png";